import React from 'react';
import loadable from '@loadable/component';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { propTypes } from '../../util/types';
import logoNewImage from '../../assets/images/logo_new.png';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
// import CardGrid from '../../components';
import css from './FarmiezFieldGuidesPage.module.css';

import { Page, CardGrid } from '../../components';
// import FallbackPage, { fallbackSections } from './FallbackPage';
// import { ASSET_NAME } from './GettingPaidPage.duck';
// import { camelize } from '../../util/string';
// import { getMetadata } from '../PageBuilder/PageBuilder';
// import { isScrollingDisabled } from '../../ducks/ui.duck';

export const FarmiezFieldGuidesPageComponent = props => {
  // const { pageAssetsData } = props;
  // const { meta = {} } = pageAssetsData?.[camelize(ASSET_NAME)]?.data || {};
  // const pageMetaProps = getMetadata(meta, 'Article');

  return (
    <Page>
      <div 
        className={css.FarmiezFieldGuidesPage}
        style={{
          backgroundImage: `url(${require('../../assets/images/woodBg.jpg')})`,
        }}
      >
        <TopbarContainer />

        {/* Hero Section */}
        <div
          className={css.heroSection}
          style={{
            // backgroundImage: `url(${require('../../assets/images/gettingPaid.png')})`,
          }}
        >
          <div className={css.heroContainer}>
            <img src={logoNewImage} alt="Farmiez Logo" className={css.faqLogo} />
            <h1 className={css.heroTitle}>Farmiez Field Guides</h1>
          </div>
        </div>

        <div className={css.gettingPaidContentWrap}>
          <div className={css.content}>
            <p className={css.intro}>
              Stories, how-to guides, recipes, and farmyard wisdom from "The Chicken Man" series — curated for backyard chicken keepers, dreamers, and future farmers.
            </p>
            <div className={css.textBlock}>
              <CardGrid />
            </div>
          </div>

        </div>
        
        <FooterContainer />
      </div>
    </Page>
  );
};

FarmiezFieldGuidesPageComponent.propTypes = {
  // pageAssetsData: object,
  // inProgress: bool,
  // error: propTypes.error,
};

const mapStateToProps = state => {
  // const { pageAssetsData } = state.hostedAssets || {};

  // return {
  //   pageAssetsData,
  //   scrollingDisabled: isScrollingDisabled(state),
  // };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const FarmiezFieldGuidesPage = compose(connect(mapStateToProps))(FarmiezFieldGuidesPageComponent);

export default FarmiezFieldGuidesPage;
